// Colors used across the app
export const colors = {
  shadow: "0 2px 4px rgba(0,0,0,0.1)",
  lightBg: "#f8f9fa",
  darkText: "#343a40",
  sidebarBg: "#343a40",
  sidebarActiveBg: "#495057",
  white: "#fff",
  primary: "#0d6efd",
};

// NavBar styles
export const navbar = {
  height: "100px",
  brand: {
    fontSize: "35px",
    fontWeight: "600",
  },
  userDropdown: {
    fontSize: "20px",
    fontWeight: "500",
  },
    // ✅ Add loginButton style
  loginButton: {
    display: "inline-block",
    padding: "5px 12px",
    borderRadius: "4px",
    backgroundColor: "transparent",
    border: "1px solid", // we'll dynamically set color from sidebarBg
    color: "", // will dynamically set from sidebarBg
    cursor: "pointer",
    fontSize: "0.9rem",
    fontWeight: "500",
    textAlign: "center",
  },
  
};

// SideBar styles
export const sidebar = {
  container: {
    width: "240px",
    background: colors.sidebarBg,
    color: colors.white,
    minHeight: "100vh",
    padding: "2rem 1rem 1rem 1rem",
    display: "flex",
    flexDirection: "column",
    fontSize: "18px",
  },
  brand: {
    color: colors.white,
    marginBottom: "1.5rem",
    fontSize: "30px",
    fontWeight: "600",
    marginLeft: "1rem",
  },
  divider: {
    borderColor: colors.white,
    borderWidth: "1px",
    width: "100%",
    marginBottom: "1rem",
  },
  navLink: (active) => ({
    color: colors.white,
    textTransform: "none",
    marginBottom: "0.5rem",
    fontWeight: active ? "700" : "500",
    backgroundColor: active ? colors.sidebarActiveBg : "transparent",
    padding: "0.5rem 1rem",
    borderRadius: "4px",
  }),
  icon: {
    marginRight: "8px",
  },
};

// Footer styles
export const footer = {
  container: {
    background: colors.lightBg,
    padding: "1rem",
    textAlign: "center",
    fontSize: "16px",
    color: colors.darkText,
    borderTop: `1px solid ${colors.shadow}`, // subtle divider
  },
};

// Typography
export const typography = {
  h2: {
    fontSize: "28px",
    fontWeight: "600",
    marginBottom: "1rem",
    color: colors.darkText,
  },
  label: {
    fontWeight: "600",
    fontSize: "16px",
    marginRight: "0.5rem",
  },
  body: {
    fontSize: "16px",
    color: colors.darkText,
    marginBottom: "0.5rem",
  },
};


// Profile page styles
// export const profile = {
//   container: {
//     padding: "1rem",
//   },
//   card: {
//     background: colors.white,
//     boxShadow: colors.shadow,
//     borderRadius: "8px",
//     padding: "1.5rem",
//     maxWidth: "500px",
//   },
//   item: {
//     marginBottom: "0.75rem",
//   },
// };



export const profile = {
  container: {
    padding: "2rem",              // more space around the card
    display: "flex",
    justifyContent: "center",     // center the card horizontally
  },
  card: {
    background: colors.white,
    boxShadow: colors.shadow,
    borderRadius: "12px",         // slightly more rounded
    padding: "2rem",              // more inner padding
    maxWidth: "700px",            // increase width from 500px to 700px
    width: "100%",                // make it responsive
  },
  item: {
    marginBottom: "1rem",         // a little more spacing between items
  },
  buttonPrimary: {
    backgroundColor: "#2255aa",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "8px 16px",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: "1rem",
  },
  buttonSecondary: {
    backgroundColor: "#f0f0f0",
    color: "#333",
    border: "1px solid #ccc",
    borderRadius: "6px",
    padding: "6px 12px",
    cursor: "pointer",
    fontSize: "0.9rem",
  },
};

// Layout styles
export const layout = {
  container: {
    display: "flex",
    minHeight: "100vh",
  },
  rightSide: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  main: {
    flex: 1,
    padding: "1rem",
    background: "#f1f3f6",
  },
};


// Form styles
export const forms = {
  group: {
    marginBottom: "1rem",
  },
  label: {
    fontWeight: "600",
    marginBottom: "0.5rem",
    display: "block",
  },
  control: {
    padding: "0.5rem",
    fontSize: "16px",
  },
  button: {
    marginTop: "1rem",
    fontWeight: "600",
  },
};


// Dashboard styles
export const dashboard = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "1rem",
    gap: "8px"
  },
  title: {
    fontSize: "28px",
    fontWeight: "600",
    margin: 3,
    textTransform: 'none' 
  },
  button: {
      padding: "0.5rem 1rem",
      fontSize: "0.9rem",
      marginLeft: "auto", // moved from JSX
    },
    modalTitle: {
      fontSize: "1.25rem",
      fontWeight: "bold",
    },
    modalBody: {
      padding: "1rem",
    },
    refreshIcon: {
      cursor: "pointer",
      width: "30px",
      height: "30px",
    },
    lastUpdatedText: {
      fontSize: "0.9rem",
      color: "#666",
    },
    description: {
      margin: "0 10px 10px 10px",  // ← left & right indentation
      padding: "14px 18px",
      backgroundColor: colors.white,
      borderRadius: "8px",
      fontSize: "15px",
      lineHeight: "1.6",
      color: colors.darkText,
      boxShadow: colors.shadow,
    },
};


// AG Grid 
export const grid = {
  container: {
    height: "auto",      // ✅ shrink to fit rows
    maxHeight: "600px",  // ✅ limit growth
    overflowY: "auto",   // ✅ scroll if taller    width: "100%",           // full width
    backgroundColor: colors.lightBg, // your app's light background
    borderRadius: "6px",
    padding: "0.5rem",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // subtle shadow for card-like feel
  },
  header: {
    fontWeight: 600,
    color: colors.darkText,
    backgroundColor: "#e0e0e0", // header background, optional
  },
  row: {
    oddBackgroundColor: "#f8fafc",
    evenBackgroundColor: "#ffffff",
    borderBottom: "1px solid #edf2f7",
  },
  cell: {
    borderRight: "1px solid #edf2f7",
    padding: "0.5rem",
    color: colors.darkText,
  },
};

import * as AGGrid from "ag-grid-community";

// AG Grid theme using Theming API
export const agGridTheme = AGGrid.themeQuartz
  .withPart(AGGrid.iconSetMaterial)
  .withPart(AGGrid.colorSchemeLightCold)
  .withParams({

  })
;

// Returns a style object to center content in AgGrid cells
export const centerCellStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
};


// Header text centering (applies a CSS class)
// export const centerHeaderStyle = "header-center";

export const defaultColDef = {
  sortable: true,
  filter: true,
  flex: 1,
  floatingFilter: true,
  cellStyle: centerCellStyle,
};


export const StatusBadgeRenderer = ({ value }) => {
  let badgeClass = "";
  switch (value) {
    case "Pending": badgeClass = "status-pending"; break;
    case "Downloading": badgeClass = "status-downloading"; break;
    case "Running": badgeClass = "status-running"; break;
    case "Completed": badgeClass = "status-completed"; break;
    case "Failed": badgeClass = "status-failed"; break;
    default: badgeClass = "";
  }

  return <span className={`status-badge ${badgeClass}`}>{value}</span>;
};



// Card container style for Outputs / Inputs
export const cardStyle = {
  marginBottom: "30px",
  padding: "15px",
  border: "1px solid #ddd",
  borderRadius: "6px",
  backgroundColor: "#f9f9f9",
};

// Card header style
export const cardHeaderStyle = {
  marginBottom: "10px",
};

// Iframe style for HTML outputs
export const iframeStyle = {
  width: "100%",
  height: 600,
  border: "1px solid #ccc",
};

// Optional: wrapper for content inside card
export const cardContentWrapper = {
  marginTop: "15px",
};


// JobDetail container
export const jobDetailContainerStyle = {
  marginTop: "20px",
  padding: "15px",
  border: "1px solid #ddd",
  borderRadius: "6px",
  backgroundColor: "#fff",
};

// JobDetail header
export const jobDetailHeaderStyle = {
  marginBottom: "15px",
};

// Errors tab container
export const errorsContainerStyle = {
  padding: "10px 0",
};

// Errors list
export const errorsListStyle = {
  color: "red",
};

// HTML report link
export const htmlReportLinkStyle = {
  fontWeight: "bold",
  textDecoration: "underline",
  marginLeft: "10px", // shifts the link slightly right
  display: "inline-block",
};

// "No data / No outputs" message
export const noDataStyle = {
  textAlign: "center",
  padding: "10px",
};

// Home
// /home/zl7w2/PHOENIX_DEV/src/styles/theme.js

export const home = {
  wrapper: {
    padding: '0 20px',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  hero: {
    textAlign: 'center',
    marginBottom: '50px',
  },
  heroLogo: {
    width: '400px',
    height: 'auto',
    marginBottom: '20px',
  },
  heroTitle: {
    fontSize: "40px",      // 🔥 Bigger than Team mainTitle (40px)
    fontWeight: "700",
    marginTop: "20px",
    marginBottom: "20px",
  },

  heroText: {
    fontSize: "20px",      // Slightly larger for balance
    maxWidth: "900px",
    margin: "0 auto",
    lineHeight: "1.6",
  },
  heroButton: {
    display: 'inline-block',
    marginTop: '20px',
    padding: '12px 25px',
    backgroundColor: '#007bff',
    color: '#fff',
    borderRadius: '6px',
    textDecoration: 'none',
    fontWeight: '500',
  },
  hr: {
    margin: '50px 0',
  },
  tileContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "25px",
    marginBottom: "60px"
  },
  tile: {
    flex: "1 1 250px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    padding: "25px 20px",
    textAlign: "center",
    minWidth: "220px",
    maxWidth: "300px",
    backgroundColor: "#fafafa",
    color: "#000",
    textDecoration: "none",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    transition: "transform 0.2s, box-shadow 0.2s",
    cursor: "pointer"
  },
  tileContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "25px",
    marginBottom: "60px"
  },
  tileDesc: {
    fontSize: "14px",
    color: "#555",
    minHeight: "70px"
  },
  tileHover: {
    boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
    transform: "translateY(-3px)"
  },
  tileDefault: {
    boxShadow: "none",
    transform: "translateY(0)"
  },


};


// Tutorial page styles
export const tutorial = {
  wrapper: {
    maxWidth: "900px",   // max width of tutorial content
    margin: "0 auto",    // center horizontally
    padding: "20px",     // inner padding
  },
  section: {
    marginBottom: "30px", 
    lineHeight: 1.6,
    color: colors.darkText,
    fontSize: "16px",
  },
  sectionHeader: {
    fontSize: "20px",
    fontWeight: 600,
    marginBottom: "15px",
  },
  list: {
    paddingLeft: "20px",   // keeps indentation
    lineHeight: "1.8",     // optional for readability
    marginBottom: "0",      // no global margin
    listStylePosition: "inside"
  },

  listItem: {
    marginBottom: "12px"   // add vertical space between <li>
  },
  pageTitle: {
  textAlign: "center",
  fontWeight: "600",
  marginBottom: "10px"
},

  pageSubtitle: {
    textAlign: "center",
    color: "#6c757d",
    marginBottom: "30px"
  },

  subTitle: {
    marginBottom: "25px",
    fontWeight: "600"
  },

  subHeader: {
    marginTop: "20px",
    fontWeight: "500"
  },

  link: {
    color: "#0d6efd",
    textDecoration: "none",
    fontWeight: "500"
  }
};


export const team = {
  section: {
    padding: "60px 20px",
    textAlign: "center",
  },

  mainTitle: {
    fontSize: "35px",
    marginBottom: "60px",
    fontWeight: "700",
  },

  subTitle: {
    fontSize: "28px",
    marginBottom: "30px",
    fontWeight: "600",
  },

  piWrapper: {
    marginBottom: "80px",
  },

  cardLarge: {
    maxWidth: "420px",
    margin: "0 auto",
    padding: "30px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.1)",
    borderRadius: "12px",
  },

  card: {
    maxWidth: "360px",
    padding: "25px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.1)",
    borderRadius: "12px",
  },

  imageLarge: {
    width: "200px",
    height: "200px",
    objectFit: "cover",
    borderRadius: "50%",
    marginBottom: "20px",
  },

  image: {
    width: "180px",
    height: "180px",
    objectFit: "cover",
    borderRadius: "50%",
    marginBottom: "20px",
  },

  nameLarge: {
    fontSize: "24px",
    fontWeight: "700",
    marginBottom: "10px",
  },

  name: {
    fontSize: "22px",
    fontWeight: "700",
    marginBottom: "8px",
  },

  role: {
    fontSize: "18px",
    fontWeight: "500",
  },

  title: {
    fontSize: "16px",
    color: "#555",
  },

  teamContainer: {
    display: "flex",
    justifyContent: "center",
  },

  footer: {
    marginTop: "60px",
    fontSize: "16px",
  },
};


export const news = {
  section: {
    padding: "60px 20px",
    maxWidth: "900px",
    margin: "0 auto",
  },

  title: {
    fontSize: "44px",
    fontWeight: "700",
    marginBottom: "40px",
  },

  card: {
    marginBottom: "40px",
    padding: "24px",
    borderRadius: "10px",
    boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
    background: "#fff",
  },

  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },

  date: {
    fontSize: "15px",
    color: "#777",
    fontWeight: "500",
  },

  tags: {
    display: "flex",
    gap: "8px",
  },

  tag: {
    fontSize: "13px",
    background: "#eef",
    padding: "4px 8px",
    borderRadius: "4px",
    color: "#225",
    fontWeight: "600",
  },

  itemTitle: {
    fontSize: "28px",
    fontWeight: "600",
    margin: "12px 0",
  },

  link: {
    textDecoration: "none",
    color: "#222",
  },

  summary: {
    fontSize: "18px",
    lineHeight: "1.6",
    color: "#333",
  },
  image : {
    width: "100%",         // image fills card width
    height: "auto",        // maintain aspect ratio
    maxHeight: "300px",    // optional max height
    borderRadius: "8px",
    marginBottom: "16px",
    objectFit: "cover",    // crop nicely if taller than maxHeight
  },
  linkButton: {
    display: "inline-block",
    marginTop: "12px",
    padding: "6px 14px",
    backgroundColor: "#2255aa",
    color: "#ffffff",
    textDecoration: "none",
    borderRadius: "6px",
    fontSize: "0.9rem",
    fontWeight: 500,
    transition: "background-color 0.2s ease",
  },

};


// example in styles/theme.js
export const faq = {
  section: {
    padding: "40px 20px",
    maxWidth: "900px",
    margin: "0 auto",
  },
  title: {
    fontSize: "36px",
    marginBottom: "24px",
    textAlign: "center",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  card: {
    borderRadius: "10px",
    padding: "16px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    background: "#fff",
  },
  question: {
    background: "none",
    border: "none",
    fontSize: "20px",
    fontWeight: "600",
    cursor: "pointer",
    textAlign: "left",
    width: "100%",
  },
  answer: {
    marginTop: "20px",
    fontSize: "16px",
    lineHeight: "1.5",
  },
  supportSection : {
    padding: "20px 0 0 0", // only top padding, remove bottom padding
  }
};